/**
 * DetailViewerPresenter
 * --
 */
import React from 'react';
import { DetailView } from 'routes/main.routes/components';
import { Empty, Flex } from 'antd';
import { Content } from 'components';
import dayjs from 'dayjs';

const DetailViewerPresenter = (props) => {
  /* ===== ROUTE ===== */
  /* ===== PROPS ===== */
  const { data = null, screenSize } = props;

  /* ===== STATE ===== */
  /* ===== VARIABLE ===== */
  /* ===== FUNCTION ===== */
  /* ===== HOOKS ===== */
  /* ===== RENDER ===== */
  if (!data)
    return (
      <Flex flex={1} justify="center" align="center" style={{ minHeight: 350 }}>
        <Empty description={'해당 게시글을 찾을 수 없습니다.'} />
      </Flex>
    );

  return (
    <Content maxWidth={'100%'} padding={0}>
      <DetailView
        screenSize={screenSize}
        title={data.title}
        type={data.type === 'notice' ? '공지' : '이벤트'}
        content={data.content}
        period={
          data.type === 'notice'
            ? [dayjs.unix(data.created).format('YYYY.MM.DD')]
            : [
                dayjs.unix(data.start).format('YYYY.MM.DD HH:mm:ss'),
                dayjs.unix(data.end).format('YYYY.MM.DD HH:mm:ss'),
              ]
        }
        color={data.type === 'notice' ? '#111111' : '#69B350'}
      />
    </Content>
  );
};

export default DetailViewerPresenter;
